import { em, Group } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import React, { useEffect } from 'react'
import { useInstantSearch } from 'react-instantsearch'
import { ExpertsFilter } from '@public/Search/ExpertsFilter'
import { Box, Container, Flex } from 'components/Layout'
import { COLOR_NAMES, SPACE } from 'Theme'
import { CurrentRefinements } from '../CurrentRefinements'
import { ExpertHits } from '../ExpertHits'
import { TypesenseMobileFilterAndSort } from '../TypesenseMobileFilterAndSort'

export const ScrollToTopOnSearchChange = () => {
  const { results } = useInstantSearch()
  useEffect(() => {
    if (results) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }, [results?.nbHits])

  return null
}

export const BasePageLayout = () => {
  const isMobile = useMediaQuery(`(max-width: ${em(768)})`)

  return (
    <Box>
      <ScrollToTopOnSearchChange />
      <>
        <Group
          justify={isMobile ? 'flex-start' : 'space-between'}
          align="flex-start"
          py="1rem"
          wrap="nowrap"
          style={{ flexDirection: isMobile ? 'column-reverse' : 'row' }}
        >
          <Container>
            <CurrentRefinements />
          </Container>
          <Box
            data-testid="123"
            display={{ MOBILE: 'block', TABLET: 'none' }}
            width="100%"
          >
            <TypesenseMobileFilterAndSort>
              <ExpertsFilter />
            </TypesenseMobileFilterAndSort>
          </Box>
        </Group>
        <Flex
          flex="1"
          flexDirection="column"
          mb={{ TABLET: SPACE.PX_40, MOBILE: SPACE.PX_5 }}
        >
          <Container>
            <Flex
              gap={{
                MOBILE: SPACE.PX_16,
                TABLET: SPACE.PX_32,
              }}
            >
              <Box
                width={{ MOBILE: '100%', TABLET: '25%' }}
                display={{ MOBILE: 'none', TABLET: 'block' }}
              >
                <Box
                  borderBottom="1px solid"
                  borderColor={COLOR_NAMES.JUPITER}
                  position="sticky"
                  top={SPACE.PX_100}
                  overflow="auto"
                  height="calc(100vh - 108px)"
                  pr="16px"
                >
                  <ExpertsFilter />
                </Box>
              </Box>
              <Box width={{ MOBILE: '100%', TABLET: '75%' }}>
                <ExpertHits />
              </Box>
            </Flex>
          </Container>
        </Flex>
      </>
    </Box>
  )
}
